import React, { useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTable } from "@fortawesome/pro-light-svg-icons";
import { Button, Grid, Drawer, withStyles, Checkbox } from "@material-ui/core";
import { connect } from 'react-redux'
import ReactSelect from '../../../../common/components/UI/Select/ReactSelect';
import { defaultRequestColumns, defaultEmployeeColumnsLeft, defaultEmployeeColumnsRight } from '../../../Manager/Requests/constants';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';

const mapStateToProps = state => {
    return {
        dataviewRequestColumns: state.dataviewRequestColumns,
        dataviewEmployee1Columns: state.dataviewEmployee1Columns,
        dataviewEmployee2Columns: state.dataviewEmployee2Columns,
        currentDataview: state.currentDataview,
        selectedManagerSetting: state.selectedManagerSetting,
    }
}

export default connect(mapStateToProps)(function DataviewFilterPanel(props) {
    const anchor = "right";
    const classes = props.classes;
    const [state, setState] = React.useState({
        right: false,
        selectedTab: 0,
        dataviewRequestColumns: [],
        dataviewEmployee1Columns: [],
        dataviewEmployee2Columns: [],
    });

    useEffect(() => {
        // Update the document title using the browser API
        setState({
            ...state,
            currentDataview: props.currentDataview,
            dataviewRequestColumns: props.dataviewRequestColumns,
            dataviewEmployee1Columns: props.dataviewEmployee1Columns,
            dataviewEmployee2Columns: props.dataviewEmployee2Columns,
        })
    }, [props.dataviewRequestColumns, props.dataviewEmployee1Columns, props.dataviewEmployee2Columns, props.currentDataview]);
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({
            ...state,
            [anchor]: open,
            selectedTab: 0,
        });
    };

    const handleInputChange = (tab, key, active) => {
        let requestColumns;
        switch (tab) {
            case 0:
                requestColumns = state.dataviewRequestColumns;
                requestColumns.find(x => x.DataviewKey === key).Active = active;
                setState({
                    ...state,
                    dataviewRequestColumns: requestColumns,
                });
                break;
            case 1:
                requestColumns = state.dataviewEmployee1Columns;
                requestColumns.find(x => x.DataviewKey === key).Active = active;
                setState({
                    ...state,
                    dataviewEmployee1Columns: requestColumns,
                });
                break;
            case 2:
                requestColumns = state.dataviewEmployee2Columns;
                requestColumns.find(x => x.DataviewKey === key).Active = active;
                setState({
                    ...state,
                    dataviewEmployee2Columns: requestColumns,
                });
                break;
            default:
                break;
        }
    }

    const selectTab = (id) => {
        setState({
            ...state,
            selectedTab: id
        });
    }

    const handleApplyFilter = () => {
        props.handleFilterDataview(state.dataviewRequestColumns, state.dataviewEmployee1Columns, state.dataviewEmployee2Columns, state.currentDataview);

        setState({
            ...state,
            [anchor]: false,
            selectedTab: 0,
        });
    }

    const handleChangeDataview = (target, dataviewSelection) => {
        const { selectedManagerSetting } = props
        let selectedAdminSetting = selectedManagerSetting[0].adminSettings.find(setting => setting.dataviewId === dataviewSelection.id)
        if (selectedAdminSetting) {
            let employee1Columns = [...defaultEmployeeColumnsLeft];
            let employee2Columns = [...defaultEmployeeColumnsLeft];
            let dataview = ''
            dataview = props.dataviewsList.find(x => x.id === selectedAdminSetting.dataviewId);
            if (dataview) {
                for (let x of dataview.fields) {
                    employee1Columns.push({ "Label": x.label, "Optional": true, "Active": selectedAdminSetting.dataviewDisplayedCols.includes(x.key), "Dataview": true, "DataviewKey": x.key });
                    employee2Columns.push({ "Label": x.label, "Optional": true, "Active": selectedAdminSetting.dataviewDisplayedCols.includes(x.key), "Dataview": true, "DataviewKey": x.key });
                }
            }

            if (selectedManagerSetting.type === 3) {
                employee1Columns.push({ "Label": "Award status", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__AWARDING" })
                employee1Columns.push({ "Label": "Seniority rank", "Optional": false, "Active": true, "Dataview": false, "DataviewKey": "DEFAULT__SENIORITY" })
            }

            //push Shift column to the left of dataview columns
            employee1Columns = employee1Columns.concat(defaultEmployeeColumnsRight);
            employee2Columns = employee2Columns.concat(defaultEmployeeColumnsRight);
            setState({
                ...state,
                currentDataview: dataviewSelection,
                dataviewRequestColumns: [...defaultRequestColumns],
                dataviewEmployee1Columns: employee1Columns,
                dataviewEmployee2Columns: employee2Columns,
            })
        }
    }

    const CustomCheckbox = withStyles({
        root: {
            fontSize: '16px',
            color: '#6EA0D7',
            padding: 0,
            backgroundColor: '#FFF',
            zIndex: 1,
            '&$checked': {
                color: '#0A54A2',
            },
            '&$disabled': {
                color: '#CCCCCC',
            },
            '& .MuiSvgIcon-root': {
                fontSize: '18px'
            }
        },
        checked: {},
        disabled: {}
    })(props => <Checkbox color="default" {...props} />);
    return (
        <React.Fragment key={anchor}>
            <CustomToolTip
                titleText={"Select dataview columns"}
                jsx={
                    <Button className={classes.moreOptionsButton} onClick={toggleDrawer(anchor, true)}>
                        <FontAwesomeIcon className={classes.iconFixHeight} icon={faTable} />
                    </Button>
                }
            />
            <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                <div className={classes.filterPanel}>
                    <div className={classes.filterPanelHeader}>
                        <Grid container >
                            <Grid item xs={6} md={6}>
                                <span className={classes.filterPanelHeaderText}> Dataview </span>
                            </Grid>
                            <Grid item xs={3} md={3}>
                                <button className={classes.buttonCancel} onClick={toggleDrawer(anchor, false)} > Cancel </button>
                            </Grid>
                            <Grid item xs={3} md={3}>
                                <button className={classes.buttonSubmit} onClick={() => handleApplyFilter()} > Apply Filters </button>
                            </Grid>
                        </Grid>
                    </div>
                    <div className={classes.dataviewPanel}>
                        <ReactSelect
                            labelText={'Select dataview'}
                            placeholder={'Select dataview'}
                            value={state.currentDataview}
                            options={props.dataviewsList}
                            onChange={handleChangeDataview}
                            classes={classes}
                        />
                    </div>
                    <div className={classes.filterPanelTabs}>
                        <Grid container >
                            <Grid item xs={3} md={3}>
                                <div className={state.selectedTab === 0 ? classes.filterPanelTabSelected : classes.filterPanelTab} onClick={() => selectTab(0)}>
                                    Requests
                                </div>
                            </Grid>
                            <Grid item xs={3} md={3}>
                                <div className={state.selectedTab === 1 ? classes.filterPanelTabSelected : classes.filterPanelTab} onClick={() => selectTab(1)}>
                                    Employee 1
                                </div>
                            </Grid>
                            <Grid item xs={3} md={3}>
                                {props.managerSetting && props.managerSetting.type !== 2 && props.managerSetting.type !== 3 ?
                                    <div className={state.selectedTab === 2 ? classes.filterPanelTabSelected : classes.filterPanelTab} onClick={() => selectTab(2)}>
                                        Employee 2
                                    </div> : null}
                            </Grid>

                        </Grid>
                    </div>

                    <div className={classes.filterPanelSelectionBox}>
                        {
                            (state.selectedTab === 0 ? state.dataviewRequestColumns : state.selectedTab === 1 ? state.dataviewEmployee1Columns : state.dataviewEmployee2Columns).map((column) => (
                                <label className={classes.alignStack}>
                                    <CustomCheckbox
                                        name={column.Label}
                                        checked={column.Active}
                                        disabled={!column.Optional}
                                        onChange={() => handleInputChange(state.selectedTab, column.DataviewKey, !column.Active)} />
                                    <span> {column.Label} </span>
                                </label>
                            ))
                        }
                    </div>
                </div>
            </Drawer>
        </React.Fragment>
    );
})
